import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import PublicIcon from "@mui/icons-material/Public";
import React, { memo } from "react";
import { getCountryCode, getCountryName } from "./companyFlags";
import "flag-icons/css/flag-icons.min.css";

interface IScopeIndicatorProps {
    dataAreaId?: string | null;
    /** ISO alpha-2 country code — used when dataAreaId isn't available */
    countryCode?: string | null;
    /** Force global display regardless of dataAreaId */
    global?: boolean;
}

function ScopeIndicator({ dataAreaId, countryCode: explicitCode, global }: IScopeIndicatorProps) {
    const code = explicitCode ?? getCountryCode(dataAreaId);
    const isGlobal = global || (!code && !dataAreaId);

    if (!isGlobal && !code) {
        return null;
    }

    return (
        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mt: 0.25, mb: 0.25 }}>
            {isGlobal ? (
                <>
                    <PublicIcon sx={{ fontSize: 12, color: "text.disabled" }} />
                    <Typography variant="caption" color="text.disabled" sx={{ fontSize: "0.65rem", lineHeight: 1 }}>
                        Global
                    </Typography>
                </>
            ) : (
                <>
                    <Box
                        sx={{
                            width: 14,
                            height: 10,
                            borderRadius: "2px",
                            overflow: "hidden",
                            flexShrink: 0,
                            boxShadow: "0 0 0 0.5px rgba(0,0,0,0.1)",
                            filter: "saturate(0.4) brightness(1.1)",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            lineHeight: 1,
                        }}
                        className={`fi fi-${code!.toLowerCase()}`}
                    />
                    <Typography variant="caption" color="text.disabled" sx={{ fontSize: "0.65rem", lineHeight: 1 }}>
                        {getCountryName(code)}
                    </Typography>
                </>
            )}
        </Stack>
    );
}

export default memo(ScopeIndicator);
